import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AlertWarning32Icon extends BaseIcon {
  getChildren = () => [
    <path d="M31.68 27.71L18.5 1.57a2.78 2.78 0 00-5 0L.32 27.71a3 3 0 00.09 2.87A2.8 2.8 0 002.82 32h26.36a2.8 2.8 0 002.41-1.42 3 3 0 00.09-2.87zM15 9a1 1 0 012 0v13a1 1 0 01-2 0zm1 19.5a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.5z" fill="#ffb72d" fillRule="evenodd"/>
    ]
  getViewBox = () => '0 0 32 32'
}
